// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"acca68a3","19":"e7519a6a","545":"f073cd87","561":"840c4c4e","676":"28fd459d","976":"54170d53"}[chunkId] + ".chunk.js";
};